export const useCompanyStore = defineStore('company', () => {
  const apiCompany = useApiCompany()

  const company = ref(null)

  async function getCompany(slug: string) {
    const data = await apiCompany.getCompanyBySlug(slug)
    company.value = data
    return data
  }

  async function updateCompany(body: any) {
    const data = await apiCompany.updateCompany(company.value?.id, body)
    company.value = data
    return data
  }

  return {
    company,
    getCompany,
    updateCompany,
  }
})
